"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _PersonCategoryFields = _interopRequireDefault(require("./PersonCategoryFields"));

var _index = require("../../fields/index");

var _personCategoryConfig = require("./personCategoryConfig");

var _flowRuntime = _interopRequireDefault(require("flow-runtime"));

var PersonCategoryDefinition = _flowRuntime["default"].tdz(function () {
  return _personCategoryConfig.PersonCategoryDefinition;
});

var Props = _flowRuntime["default"].type("Props", _flowRuntime["default"].object(_flowRuntime["default"].property("personCategory", _flowRuntime["default"].ref(PersonCategoryDefinition)), _flowRuntime["default"].property("parentKey", _flowRuntime["default"].string(), true), _flowRuntime["default"].property("queryParams", _flowRuntime["default"].object(), true)));

var PersonCategory = function PersonCategory(_arg) {
  var personCategory = _arg.personCategory,
      parentKey = _arg.parentKey,
      queryParams = _arg.queryParams;
  var querySupporterId = queryParams && queryParams.supporterId;
  var queryDonorId = queryParams && queryParams.donorId;
  return /*#__PURE__*/_react["default"].createElement(_index.FormComponentWrapper, {
    component: personCategory,
    parentKey: parentKey,
    hideComponentLabel: querySupporterId || queryDonorId,
    renderComponent: function renderComponent(_ref) {
      var componentKey = _ref.componentKey;
      return /*#__PURE__*/_react["default"].createElement(_PersonCategoryFields["default"], {
        componentKey: componentKey,
        personCategory: personCategory,
        queryParams: queryParams
      });
    },
    showErrorsWhenAnyTouched: [_personCategoryConfig.donor.key, _personCategoryConfig.donorId.key, _personCategoryConfig.supporter.key, _personCategoryConfig.supporterId.key]
  });
};

PersonCategory.defaultProps = {
  queryParams: {},
  parentKey: undefined
};
var _default = PersonCategory;
exports["default"] = _default;